import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './BlueprintTagFilter.module.css';

const DEFAULT_VISIBLE_TAGS = 12;

interface Props {
  tags: string[];
  activeTags: string[];
  onToggleTag: (tag: string) => void;
}

const BlueprintTagFilter = ({ tags, activeTags, onToggleTag }: Props) => {
  const { t } = useTranslation('blueprints');
  const [expanded, setExpanded] = useState(false);

  if (tags.length === 0) return null;

  const hasOverflow = tags.length > DEFAULT_VISIBLE_TAGS;
  const visible = expanded ? tags : tags.slice(0, DEFAULT_VISIBLE_TAGS);

  return (
    <div className={styles.bar}>
      {visible.map(tag => {
        const active = activeTags.includes(tag);
        return (
          <button
            key={tag}
            type="button"
            data-test="bp-tag"
            className={`${styles.chip} ${active ? styles.active : ''}`}
            onClick={() => onToggleTag(tag)}
          >
            {tag}
          </button>
        );
      })}
      {hasOverflow && (
        <button type="button" data-test="bp-tag-toggle" className={styles.toggle} onClick={() => setExpanded(e => !e)}>
          {expanded ? t('tags.showLess') : t('tags.showMore')}
        </button>
      )}
    </div>
  );
};

export default BlueprintTagFilter;
